import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const CANCEL_PROJECT_INVITATION_MUTATION = gql`
  mutation CancelProjectInvitation($id: ID!) {
    cancelProjectInvitation(id: $id) {
      invitation {
        id
        email
        status
      }
    }
  }
`;

interface UseCancelProjectInvitationOptions {
  onCompleted?: () => void;
}

export function useCancelProjectInvitation(options?: UseCancelProjectInvitationOptions) {
  const [cancelMutation, { loading, error }] = useMutation(CANCEL_PROJECT_INVITATION_MUTATION, {
    onCompleted: options?.onCompleted,
  });

  const cancelProjectInvitation = async (invitationId: string) => {
    const { data } = await cancelMutation({
      variables: { id: invitationId },
      refetchQueries: ['Project'],
    });
    return (data as any)?.cancelProjectInvitation?.invitation;
  };

  return { cancelProjectInvitation, loading, error };
}
